export const styles = {
  card: {
    p: 1,
    borderRadius: "20px",
    bgcolor: "#FDFDFD",
    boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.25)",
    justifyContent: "center",
    width: "95%",
    marginTop: "6px",
  },
  disclaimerHeading: {
    color: "#121959",
    textAlign: "center",
    fontFamily: "Inter, sans-serif",
    // fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
    paddingBottom: "12px",
  },
  disclaimerPoints: {
    color: "#000",
    fontFamily: "Inter, sans-serif",
    // fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
  },
  disclaimerGrid: {
    width: "97%",
    paddingTop: "24px",
  },
};
